<form [formGroup]="CompanyForm" (ngSubmit)="saveCompany()" #companyForm="ngForm" novalidate>
    <div class="card full-dashboard-bgcover">
        <div class="card-body">
            <div class="add-job-sections common-popup-ui">
                <h5>Company Profile</h5>
                <div class="row">
                    <div class="col-md-12 col-12">
                        <div class="form-group mb-4">
                            <label>{{CompanyConstant.COMPANY_NAME}}<span class="form-control-danger">*</span></label>
                            <input type="text" class="form-control
                                form-control-lg" required autocomplete="off" formControlName="CompanyName"
                                placeholder="Enter Company Name"
                                [ngClass]="{'form-control-danger': submittedCompanydetail && companyFormControl['CompanyName'].errors?.['required']}"
                                maxlength="250" oninput="this.value = this.value.replace(/^\s+/g, '')">
                            <span class="text-danger"
                                *ngIf="submittedCompanydetail && companyFormControl['CompanyName'].errors?.['required']">
                                {{errorMessage.CompanyNameRequired}}
                            </span>
                        </div>
                    </div>
                    <div class="col-md-12 col-12">
                        <div class="form-group mb-4">
                            <label>{{CompanyConstant.EMAIL}}<span class="form-control-danger">*</span></label>
                            <input type="text" class="form-control
                                form-control-lg" required autocomplete="off" formControlName="EmailId"
                                placeholder="Enter Email Id"
                                [ngClass]="{'form-control-danger': submittedCompanydetail && companyFormControl['EmailId'].errors?.['required']}"
                                maxlength="250" oninput="this.value = this.value.toLowerCase().replace(/^\s+/g, '')">
                            <span class="text-danger"
                                *ngIf="submittedCompanydetail && companyFormControl['EmailId'].errors?.['required']">
                                {{commonErrorMessage.EmailIdIsRequired}}
                            </span>
                            <span class="text-danger"
                                *ngIf="submittedCompanydetail && companyFormControl['EmailId'].errors?.['pattern']">{{commonErrorMessage.EmailIsInvalid}}</span>
                        </div>
                    </div>
                    <div class="col-md-12 col-12">
                        <div class="form-group mb-4">
                            <label>{{CompanyConstant.MOBILE_NO}}<span class="form-control-danger">*</span></label>
                            <input type="text" maxlength="10" minlength="10" class="form-control
                                form-control-lg" (keypress)="keyPressNumbers($event)" required autocomplete="off"
                                formControlName="MobileNo" placeholder="Enter Mobile No"
                                [ngClass]="{'form-control-danger': submittedCompanydetail && companyFormControl['MobileNo'].errors?.['required']}"
                                oninput="this.value = this.value.replace(/^\s+/g, '')">
                            <span class="text-danger"
                                *ngIf="submittedCompanydetail && companyFormControl['MobileNo'].errors?.['required']">
                                {{commonErrorMessage.MobileNumberIsRequired}}
                            </span>
                            <span class="text-danger"
                                *ngIf="submittedCompanydetail && companyFormControl['MobileNo'].errors?.['pattern']">{{commonErrorMessage.MobileaNumberIsInvalid}}</span>
                        </div>
                    </div>
                    <div class="col-md-12 col-12">
                        <div class="form-group mb-4">
                            <label>{{CompanyConstant.ADDRESS}}<span class="form-control-danger">*</span></label>
                            <input type="text" class="form-control
                                form-control-lg" required autocomplete="off" formControlName="Address"
                                placeholder="Enter Address"
                                [ngClass]="{'form-control-danger': submittedCompanydetail && companyFormControl['Address'].errors?.['required']}"
                                maxlength="250" oninput="this.value = this.value.replace(/^\s+/g, '')">
                            <span class="text-danger"
                                *ngIf="submittedCompanydetail && companyFormControl['Address'].errors?.['required']">
                                {{commonErrorMessage.AddressIsRequired}}
                            </span>
                        </div>
                    </div>
                    <div class="col-md-12 col-12">
                        <div class="form-group mb-4">
                            <label>{{CompanyConstant.COMPANY_WEBSITE}}</label>
                            <input type="text" class="form-control
                                form-control-lg" autocomplete="off" formControlName="CompanyWebsite"
                                placeholder="Ex. https://xyz.com" maxlength="250"
                                oninput="this.value = this.value.replace(/^\s+/g, '')">
                            <span class="text-danger"
                                *ngIf="submittedCompanydetail && companyFormControl['CompanyWebsite'].errors?.['pattern']">
                                {{commonErrorMessage.InvalidWebsiteFormat}}
                            </span>
                            <span class="text-danger"
                                *ngIf="submittedCompanydetail && companyFormControl['CompanyWebsite'].errors?.['required']">
                                {{errorMessage.CompanyWebsiteIsRequired}}
                            </span>
                        </div>
                    </div>
                    <div class="col-md-12 col-12">
                        <div class="form-group mb-4">
                            <label>{{CompanyConstant.COMPANY_ABOUT}}<span class="form-control-danger">*</span></label>
                            <textarea class="form-control form-control-lg" autocomplete="off"
                                formControlName="CompanyAbout" placeholder="Enter About Company"
                                oninput="this.value = this.value.replace(/^\s+/g, '')">
                        </textarea>
                            <span class="text-danger"
                                *ngIf="submittedCompanydetail && companyFormControl['CompanyAbout'].errors?.['required']">
                                Please enter about company.
                            </span>
                        </div>
                    </div>
                    <div class="col-md-12 col-12">
                        <div class="form-group mb-4">
                            <label>{{CompanyConstant.INDUSTRY}}<span class="form-control-danger">*</span></label>
                            <input type="text" class="form-control
                                form-control-lg" autocomplete="off" formControlName="CompanyType"
                                placeholder="Company Industry" oninput="this.value = this.value.replace(/^\s+/g, '')">
                            <span class="text-danger"
                                *ngIf="submittedCompanydetail && companyFormControl['CompanyType'].errors?.['required']">
                                Please enter company type.
                            </span>
                        </div>
                    </div>
                    <div class="col-md-12 col-12">
                        <div class="form-group mb-4">
                            <label>{{CompanyConstant.COMPANY_SIZE}}<span class="form-control-danger">*</span></label>
                            <input type="text" class="form-control
                                form-control-lg" autocomplete="off" formControlName="CompanySize"
                                placeholder="Company Size" oninput="this.value = this.value.replace(/^\s+/g, '')">
                            <span class="text-danger"
                                *ngIf="submittedCompanydetail && companyFormControl['CompanySize'].errors?.['required']">
                                Please enter company size.
                            </span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label>{{CompanyConstant.COMPANY_LOGO}}</label>
                        <div class="d-flex align-items-center">
                            <div class="position-relative clguploadimg companyprofileimg">
                                <img id="companyProfilePreview" src="../../../../../assets/img/logo_placeholder.svg"
                                    title="Company logo" class="mt-2" alt="image">
                                <button type="button" class="btn btn-primary btn-round" (click)="file.click()"
                                    title="Upload Company Logo"><i class="fa-solid fa-camera"></i></button>
                            </div>
                        </div>
                        <input class="d-none" type="file" class="custom-file-input test" accept=".png, .jpg, .jpeg"
                            id="uploadCompanyImage" (change)="onFileChanged($event)" #file>
                        <span id="companyProfileName"></span>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="d-flex justify-content-center flex-sm-row flex-column mt-3 mb-3">
                        <button type="submit" class="btn common-button me-3"
                            id="btn-save">{{commonConstant.UPDATE}}</button>
                        <button type="button" class="btn btn-border common-button"
                            (click)="onCancel()">{{commonConstant.CANCEL}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>